export const componentNameConstants = {
  NTC_PAGE: "ntc_page",
  FPR_CREDIT_INSIGHTS: "fpr_credit_insights",
  FPR_SHORT_FORM_PRIMARY_CTA: "fpr_short_form_primary_cta",
  FPR_SHORT_FORM_SECONDARY_CTA: "fpr_short_form_secondary_cta",
  FPR_SHORT_FORM_CLOSE_CTA: "fpr_short_form_close_cta",
  FORM_SUBMIT_YES: "YES",
  FORM_SUBMIT_NO: "NO",
  FORM_SUBMIT_BUTTON: "form_submit_button",
  FORM_SUBMIT_BUTTON_NAME: "CONTINUE",
  FORM_DROPDOWN: "form_dropdown",
  KEY_FEATURES: "key_features",
  FEATURES_AND_BENEFITS: "features_and_benefits",
  CIBIL_SCORE_METER: "cibil_score_meter",
  PRODUCT_CAROUSEL_BANNER: "Product Carousel Banner",
  SIGN_IN_WITH_DESCRIPTION: "sign_in_with_description",
  TITLE_LIST_CTA: "title_list_cta",
  VIDEO_PLAYED: "VIDEO_PLAYED",
  VIDEO_STARTED: "video_started",
  VIDEO_CAROUSEL: "video_carousel",
  CAMPAIGN_HEADER: "campaign_header",
  //
  ARTICLES_CAROUSEL: "articles_carousel",
  ARTICLES_AND_INSIGHTS: "articles-and-insights",
  ICON_CLICK: "icon_click",
  SCRIP_OVERVIEW: "scrip_overview",
  BREADCRUMB: "breadcrumb",
  FAQ: "faq",
  // ✅ Existing
  STOCK_MODAL: "stock_modal",
  STOCK_FUNDAMENTALS: "stock_fundamentals",
  SCRIP_FINANCIALS: "scrip_financials", // Info Icon click tracking
  STOCK_PERFORMANCE: "stock_performance", // ✅ Added for Stock Performance section
  MARKET_SECURITIES: "market_securities",
  FOOTER_COMPONENT: "footer",
  HeaderSignIn: "HeaderSignIn",
  HEADER_NOTIFICATION: "header_notification",
  TRENDING_OFFERS: "TRENDING_OFFERS",
  TOP_NAVIGATION_BAR_HEADER: "top_navigation_bar_header",
  SEARCH_BAR: "search_bar",
  BOTTOM_NAVIGATION: "bottom_navigation",

  // ✅ Newly added
  SUBSCRIPTION_CARD_CAROUSEL: "subscription_card_carousel",
  STOCK_LIST_CARD: "stock_list_card",

  // ✅ Trading Mall components
  STOCK_INFO: "stock_info",
  SIMILAR_STOCKS: "similar_stocks",
  OPEN_DEMAT_BUTTON: "open_demat_button",
  TECHNICAL_SUMMARY: "technical_summary",
  SHAREHOLDING_PATTERN: "shareholding_pattern",
  STOCK_PERFORMANCE_GRAPH: "stock_performance_graph",
  IPO_SCRIP_FINANCIALS: "IPO_SCRIP_FINANCIALS",
  IPO_SCRIP_STRENGTHS_RISKS: "ipo_scrip_strengths_risks",
  IPO_LEAD_MANAGER: "ipo_lead_manager",

  //B2B Clp components
  LOCATOR_TILES: "locator_tiles",
  LISTING_TILES_WITH_SCROLL: "listing-tiles-with-scroll",
  LOCATION_STRIP: "location_strip",
  MOST_VIEWED_PRODUCTS: "most_viewed_products",
  TOP_DEALS: "top_deals",
  EXPLORE_BUYING_GUIDES: "explore_buying_guides",
  RECOMMENDED_PRODUCTS: "recommended_products",
  VIEWONLINEBUYOFFLINE: "view_online_buy_offline",
  BLOCKBUSTERFRIDAY: "BlockBusterFriday",
  NEWLAUNCHPRODUCTS: "bm_new_launch_component",
  TITLE_OFFER_BANNER: "title_offer_banner",
  // ✅ StoryBlock and VideoGrid specific elements
  LIVE_COMMERCE_PAGE_CLICKED: "LIVE_COMMERCE_PAGE_CLICKED",
  LIVE_COMMERCE_PAGE_VIEWED: "LIVE_COMMERCE_PAGE_VIEWED",
  LIVE_COMMERCE_CLP: "LIVE_COMMERCE_CLP",
  PAGE_NAME: "PIP_VIDEO_PLAY",
  LIVE_COMMERCE: "LIVE_COMMERCE",
  LIVE_SESSIONS: "LIVE_SESSIONS",
  VIDEO_VIEWED: "VIDEO_VIEWED",
  VIDEO_CLICKED: "VIDEO_CLICKED",
  EP_EVENT_TYPE: "view",
  // ✅ StoryBlock component
  STORY_BLOCK: "STORY_BLOCK",
  VIDEO_GRID: "video_grid",
  UPCOMING_LIVE: "upcoming_live",
  FORM_WIDGET: "form_widget",
  BANNER_CAROUSEL: "banner_carousel",
  LOAN_AMOUNT_INPUT_PDP: "loan_amount_input_pdp",
  SELECT_LOAN_AMOUNT: "select_loan_amount",
  CAROUSEL_BANNER_360: "carousel_banner_360",
  CAROUSEL_BANNER_ID: "carousel_banner",
  PRODUCT_INFO: "product_info",
  MASTER_CTA_BUTTON_FLOATING: "master_cta_button_floating",
  CONTENT_CARDS_FAQS_LIST: "content_cards_faqs_list",
  FREQUENTLY_ASKED_QUESTIONS: "frequently_asked_questions",
  CONTENT_CARDS_INFORMATION_DESCRIPTIVE_CONTENT_LIST:
    "content_cards_information_descriptive_content_list",
  BENEFITS_OF_SOLAR_LOAN: "benefits_of_solar_loan",
  CONTENT_CARDS_FEATURES_AND_BENEFITS: "content_cards_features_and_benefits",
  CATEGORY_LISTING: "category_listing",
  CONTENT_CARDS_ELIGIBILITY_AND_CRITERIA: "content_cards_eligibility_and_criteria",
  ELIGIBILITY_CRITERIA_AND_DOCUMENT_REQUIRED: "eligilibity_criteria_and_document_required",
  NAVIGATION_TABS_HEADER_SELECTION: "navigation_tabs_header_selection",
  SECONDARY_NAVIGATION_TABS: "secondary_navigation_tabs",
  RELATED_LINKS_CONTENT_HYPERLINKS: "related_links_content_hyperlinks",
  RELATED_LINKS: "related_links",
  NAVIGATION_BREADCRUMB_LINK: "navigation_breadcrumb_link",
  YOU_ARE_HERE: "you_are_here",
  CHECK_LOAN_ELIGIBILITY: "check_loan_eligibility",
  CHECK_LOAN_ELIGIBILITY_ENTER_MOBILE: "check_loan_eligibility_enter_mobile",
  CHECK_ELIGIBILITY_ENTER_MOBILE_BUTTON: "check_eligibility_enter_mobile_button",
  DISCLAIMER: "disclaimer",
  VERTICAL_VIDEO_CAROUSEL: "vertical_video_carousel",
  WATCH_OUR_REELS: "watch_our_reels",
  // ✅ Experian Drawer components
  EXPERIAN_DRAWER: "experian_drawer",
  INPUT_TEXT_FIELD: "input_text_field",
  // ✅ SolarForm components
  TERMS_AND_CONDITIONS: "terms_and_conditions",
  POPUP_LIST_SELECTION: "popup_list_selection",
  MASTER_CTA_BUTTON: "master_cta_button",
  NOTE_BANNER: "note_banner",
  // ✅ Exit Modal Drawer (Solar Form)
  EXIT_MODAL_DRAWER: "drawer_post_your_question_input_drawer",
  // ✅ Feedback Modal Drawer (Solar Form)
  FEEDBACK_MODAL_DRAWER: "drawer_feedback_input_checkbox",
  // ✅ Failure Scenarios (Location Unserviceable Page)
  FAILURE_SCENARIOS: "failure_scenarios",
  // ✅ Product Card Components (Location Unserviceable Page)
  PRODUCT_CARD_GRID: "product_card_grid",
  PRODUCT_LIST: "product_list",
  STORE_DEALS: "store_deals",
};

export const dlElementConstants = {
  FPR_FORM: "FPR_FORM_PAGE",
  FPR_FORM_SECTION: "PERSONAL DETAILS",
  CLP_CHECK_PAGE: "CLP CHECK PAGE",
  KEY_FEATURE_ACCORDION_OPENED: "KEY_FEATURE_ACCORDION_OPENED",
  EP_EXPERIAN_PAGE_NAME: "EXPERIAN PAGE",
  SYSTEM_ERROR_PAGE: "SYSTEM_ERROR_PAGE",
  VALID_ERROR_PAGE: "VALID_ERROR_PAGE",
  CIBIL_SCORE_METER_SUBS_EXPIRED_OLD_REPORT: "cibil_score_meter_subscription_expired_report_button",
  CIBIL_SCORE_METER_DOWNLOAD_REPORT_BUTTON: "cibil_score_meter_download_report_button",
  FPR_CREDIT_INSIGHTS_DROPDOWN: "fpr_credit_insights_dropdown",
  FPR_SHORT_FORM_PRIMARY_CTA_CLICK: "fpr_short_form_primary_cta_click",
  FPR_SHORT_FORM_SECONDARY_CTA_CLICK: "fpr_short_form_secondary_cta_click",
  FPR_SHORT_FORM_CLOSE_CLICK: "fpr_short_form_close_click",
  FPR_EXIT_MODAL_EXIT_CTA_CLICK: "exit_modal_exit_cta_click",
  FPR_EXIT_MODAL_STAY_CTA_CLICK: "exit_modal_stay_cta_click",
  CAMPAIGN_HEADER_FEEDBACK_MODAL_CHECKBOX: "feedback_checkbox",
  CAMPAIGN_HEADER_FEEDBACK_MODAL_CLS_BUTTON: "feedback_modal_close_button",
  FORM_SUBMIT_BUTTON_CLICK: "form_submit_button_click",
  FORM_DROPDOWN_SELECTION: "form_dropdown_selection",
  KEY_FEATURES_LINK_CLICK: "key_features_link_click",
  KEY_FEATURES_ACCORDION_DROPDOWN: "key_features_accordion_dropdown",
  FEATURE_CARD: "feature_card",
  CIBIL_SCORE_METER_NTC_KNOW_WHY_BUTTON: "cibil_score_meter_ntc_know_why_button",
  VIDEO_CLICK: "video_click",
  IMAGE_CLICK: "image_click",
  PRODUCT_CAROUSEL_BANNER_IMAGE_VIDEO_CLICK: "product_banner_slide_click",
  SIGN_IN_WITH_DESCRIPTION_LINK_CLICK: "sign_in_with_description_link_click",
  TITLE_LIST_CTA_BUTTON_CLICK: "title_list_cta_button_click",
  CAROUSEL_ARROW_PREV_ICON: "carousel_arrow_prev_icon",
  CAROUSEL_ARROW_NEXT_ICON: "carousel_arrow_next_icon",
  CAMPAIGN_HEADER_ACTIVE_TITLE: "campaign_header",
  CAMPAIGN_HEADER_BACK_BUTTON: "campaign_header_back_button",
  WISHLIST_CARD_CAROUSEL_ARROW: "wishlist_card_carousel_arrow",
  ARTICLES_CAROUSEL_LINK_CLICK: "articles_carousel_link_click",
  ARTICLE_LIST_READ_MORE: "article_list_read_more",
  ARTICLE_LIST_VIEW_ALL: "article_list_view_all",
  ARTICLE_LIST_CARDS: "article_list_cards",
  SCRIP_OVERVIEW_READ_MORE: "scrip_overview_read_more",
  FAQ_DROPDOWN: "faq_dropdown",
  // ✅ Existing elements
  SCRIP_OVERVIEW_BTN_CLICK: "scrip_overview_button_close",
  SCRIP_OVERVIEW_ICON_CLICK: "scrip_overview_icon_close",
  BREADCRUMB_LINK_CLICK: "breadcrumb_link_click",
  TRADING_MALL_STOCK_PLP: "TRADING MALL STOCK PLP",
  MARKET_SECURITIES_BTN_CLICK: "market_securities_button_click",
  // ✅ Newly added elements for Stock Fundamentals and Performance DL tracking
  OPEN_ICON: "open_icon",
  INFO_ICON: "info_icon",
  PDP_CLICKED: "TRADINGMALL_DETAILS_SUBMITTED",
  FUNDAMENTALS: "fundamentals",
  FINANCIALS: "financials",
  STOCK_FUNDAMENTALS_BTN_CLICK: "stock_fundamentals_button_close",
  STOCK_FUNDAMENTALS_ICON_CLICK: "stock_fundamentals_icon_close",
  SCRIP_FINANCIALS_BTN_CLICK: "scrip_financials_button_click",
  SCRIP_FINANCIALS_ICON_CLICK: "scrip_financials_icon_click",
  SCRIP_FINANCIALS_TAB_CLICK: "scrip_financials_tab_click",
  IPO_SCRIP_FINANCIALS_TAB_CLICK: "ipo_scrip_financials_tab_click",
  IPO_SCRIP_STRENGTHS_RISKS_TAB_CLICK: "ipo_scrip_strengths_risks_tab_click",
  IPO_SCRIP_STRENGTHS_RISKS_BTN_CLICK: "ipo_scrip_strengths_risks_btn_click",
  IPO_LEAD_MANAGER_BTN_CLICK: "ipo_lead_manager_btn_click",
  TRADING_MALL_STOCK_PDP: "TRADING MALL STOCK PDP",
  STOCKS: "STOCK",
  TAB_CLICK: "tab_click",
  // ✅ Newly added for Stock Performance
  STOCK_PERFORMANCE: "stock_performance",

  // ✅ Newly added for Subscription Card Carousel
  SUBSCRIPTION_CARD_CAROUSEL_CTA: "subscription_card_carousel_cta",

  // ✅ Trading Mall specific elements
  OPEN_DEMAT_BUTTON: "Open_Demat_Button",
  OPEN_DEMAT_BUTTON_SUBMIT: "open_demat_button_submit",
  CLOSE_ICON: "close_icon",
  SIMILAR_STOCKS_CARD_CLICK: "similar_stocks_card_click",
  TECHNICAL_SUMMARY_TAB_CLICK: "technical_summary_tab_click",
  SHAREHOLDING_PATTERN_TAB_CLICK: "shareholding_pattern_tab_click",
  SHAREHOLDING_PATTERN_BUTTON_CLICK: "shareholding_pattern_button_click",
  STOCK_LIST_VIEW_ALL_CLICK: "Stock_list_view_all_click",
  STOCK_PERFORMANCE_GRAPH_DURATION_BTN: "stock_performance_graph_duration_btn",
  NOTIFICATION_DELETE_ICON: "notification_delete_icon",
  NOTIFICATION_BELL_ICON: "notification_bell_icon",
  FOOTER_GO_TO_TOP: "footer_go_to_top",
  TRENDING_OFFERS_MODAL_BUTTON_CTA: "TRENDING_OFFERS_MODAL_BUTTON_CTA",
  BANNER_CAROUSEL_CTA: "banner_carousel_cta",

  // B2B Clp elements
  LOCATOR_TILES_SHOW_MORE_CTA: "locator_tiles_show_more_cta",
  LOCATOR_TILES_SHOW_LESS_CTA: "locator_tiles_show_less_cta",
  LOCATOR_TILES_CARD: "locator_tiles_card",
  LISTING_ICONS_CARDS: "listing_icons_cards",
  LISTING_ICONS_VIEWALL_CTA: "listing_icons_viewall_cta",
  LISTING_ICONS_CAROUSEL_ARROW: "listing_icons_carousel_arrow",
  FILTER_TAB_CLICK: "filter_tab_click",
  RECOMMENDED_PRODUCTS_CARD_CLICK: "recommended_products_card_click",
  FAQ_LINK_CLICK: "faq_link_click",
  NEW_LAUNCH_PRODUCTS_CARD_CLICK: "bm_new_launch_components_card_click",
  SWIPER_ARROW_CLICK: "swiper_arrow_click",
  OFFER_BANNER_BTN_CLICK: "offer_banner_button_click",
  PRODUCT_CARD: "product_card",
  SHOW_MORE_CTA: "show_more_cta",
  SHOW_LESS_CTA: "show_less_cta",
  CHECK_OFFERS_ACCORDION_ICON_CLICK: "check_offers_accordion_icon_click",
  CHECK_OFFERS_ACCORDION_CARD_CLICK: "check_offers_accordion_card_click",
  // Electronics On EMI specific elements
  INPUT_TEXT: "input_text",
  SEARCH_RESULT: "Search Result",
  CLEAR_RESULTS_CTA_CLICK: "clear_results_cta_click",
  PRODUCT_CARD_CLICK: "product_card_click",
  // ✅ StoryBlock and VideoGrid specific elements
  LIVE_COMMERCE_PAGE_CLICKED: "LIVE_COMMERCE_PAGE_CLICKED",
  LIVE_COMMERCE_PAGE_VIEWED: "LIVE_COMMERCE_PAGE_VIEWED",
  LIVE_COMMERCE_CLP: "LIVE_COMMERCE_CLP",
  PAGE_NAME: "PIP_VIDEO_PLAY",
  LIVE_COMMERCE: "LIVE_COMMERCE",
  LIVE_SESSIONS: "LIVE_SESSIONS",
  VIDEO_VIEWED: "VIDEO_VIEWED",
  VIDEO_CLICKED: "VIDEO_CLICKED",
  EP_EVENT_TYPE: "view",
  FORM_WIDGET_CTA_CLICK: "form_widget_cta_click",
  CAROUSEL_BANNER_360_BANNER_CLICK: "carousel_banner_360_banner_click",
  CAROUSEL_BANNER_360_CAROUSEL_CLICK: "carousel_banner_360_carousel_click",
  PRODUCT_INFO_LINK_CLICK: "product_info_link_click",
  MASTER_CTA_BUTTON_FLOATING_BUTTON_CLICK: "master_cta_button_floating_button_click",
  CONTENT_CARDS_FAQS_LIST_ICON_CLICK: "content_cards_faqs_list_icon_click",
  CONTENT_CARDS_FAQS_LIST_LINK_CLICK: "content_cards_faqs_list_link_click",
  CONTENT_CARDS_FAQS_LIST_TAB_CLICK: "content_cards_faqs_list_tab_click",
  CONTENT_CARDS_INFORMATION_DESCRIPTIVE_CONTENT_LIST_ICON_CLICK:
    "content_cards_information_descriptive_content_list_icon_click",
  CONTENT_CARDS_FEATURES_AND_BENEFITS_ICON_CLICK: "content_cards_features_and_benefits_icon_click",
  CATEGORY_LISTING_ICON_CLICK: "category_listing_icon_click",
  CONTENT_CARDS_ELIGIBILITY_AND_CRITERIA_ICON_CLICK:
    "content_cards_eligibility_and_criteria_icon_click",
  CONTENT_CARDS_ELIGIBILITY_AND_CRITERIA_LINK_CLICK:
    "content_cards_eligibility_and_criteria_link_click",
  NAVIGATION_TABS_HEADER_SELECTION_ICON_CLICK: "navigation_tabs_header_selection_icon_click",
  NAVIGATION_TABS_HEADER_SELECTION_TAB_CLICK: "navigation_tabs_header_selection_tab_click",
  RELATED_LINKS_CONTENT_HYPERLINKS_LINK_CLICK: "related_links_content_hyperlinks_link_click",
  NAVIGATION_BREADCRUMB_LINK_LINK_CLICK: "navigation_breadcrumb_link_link_click",
  CHECK_LOAN_ELIGIBILITY_BUTTON_CLICK: "check_loan_eligibility_button_click",
  DISCLAIMER_LINK_CLICK: "disclaimer_link_click",
  VERTICAL_VIDEO_CAROUSEL_VIDEO_CLICK: "vertical_video_carousel_video_click",
  VERTICAL_VIDEO_CAROUSEL_CAROUSEL_CLICK: "vertical_video_carousel_carousel_click",
  VERTICAL_VIDEO_CAROUSEL_LINK_CLICK: "vertical_video_carousel_link_click",
  // ✅ Experian Drawer elements
  EXPERIAN_DRAWER_BUTTON_CLICK: "experian_drawer_button_click",
  EXPERIAN_DRAWER_ICON_CLICK: "experian_drawer_icon_click",
  EXPERIAN_DRAWER_LINK_CLICK: "experian_drawer_link_click",
  EXPERIAN_DRAWER_INPUT_FIELD_TIMING: "experian_drawer_input_field_timing",
  // ✅ SolarForm elements
  TERMS_AND_CONDITIONS_CHECKBOX_CLICK: "terms_and_conditions_checkbox_click",
  TERMS_AND_CONDITIONS_LINK_CLICK: "terms_and_conditions_link_click",
  POPUP_LIST_SELECTION_TAB_CLICK: "popup_list_selection_tab_click",
  POPUP_LIST_SELECTION_ICON_CLICK: "popup_list_selection_icon_click",
  INPUT_TEXT_FIELD_ICON_CLICK: "input_text_field_icon_click",
  INPUT_TEXT_FIELD_BFL_FIELD_TIMING: "input_text_field_bfl_fieldTiming",
  INPUT_TEXT_FIELD_BFL_PII_FIELD_TIMING: "input_text_field_bfl_piifieldTiming",
  MASTER_CTA_BUTTON_CLICK: "master_cta_button_button_click",
  NOTE_BANNER_LINK_CLICK: "note_banner_link_click",
  NOTE_BANNER_ICON_CLICK: "note_banner_icon_click",
  // ✅ Exit Modal Drawer elements
  EXIT_MODAL_DRAWER_BUTTON_CLICK: "drawer_post_your_question_input_drawer_button_click",
  EXIT_MODAL_DRAWER_ICON_CLICK: "drawer_post_your_question_input_drawer_icon_click",
  // ✅ Feedback Modal Drawer elements
  FEEDBACK_MODAL_DRAWER_BUTTON_CLICK: "drawer_feedback_input_checkbox_button_click",
  FEEDBACK_MODAL_DRAWER_ICON_CLICK: "drawer_feedback_input_checkbox_icon_click",
  FEEDBACK_MODAL_DRAWER_CHECKBOX_CLICK: "drawer_feedback_input_checkbox_checkbox_click",
  // ✅ Failure Scenarios elements
  FAILURE_SCENARIOS_BUTTON_CLICK: "failure_scenarios_button_click",
  // ✅ Product Card Grid elements
  PRODUCT_CARD_GRID_CARD_CLICK: "product_card_grid_card_click",
  PRODUCT_CARD_GRID_CAROUSEL_CLICK: "product_card_grid_carousel_click",
  // ✅ Product List elements
  PRODUCT_LIST_CARD_CLICK: "product_list_card_click",
  PRODUCT_LIST_CAROUSEL_CLICK: "product_list_carousel_click",
  // ✅ Store Deals elements
  STORE_DEALS_CARD_CLICK: "store_deals_card_click",
  STORE_DEALS_BUTTON_CLICK: "store_deals_button_click",

  // for ipo
  EXPLORE_OTHER_IPO_TAB_CLICK: "explore_other_ipo_tab_click",
  EXPLORE_OTHER_IPO_BTN_CLICK: "explore_other_ipo_btn_click",
  EXPLORE_OTHER_IPO_CARD_CLICK: "explore_other_ipo_card_click",
  VIDEO_LINK: "video_link_click",
  MEDIAWITHTEXT: "media_with_text_click",
  SECONDARY_NAVIGATION_BTN_CLICK: "secondary_navigation_button_click",
};

export enum dlEventConstants {
  DROP_DOWN_SELECTION = "DROP_DOWN_SELECTION",
  CHECKBOX_CLICK = "checkbox_click",
  CAROUSAL_PAGINATION_CLICK = "carousel_pagination_click",
  CAROUSEL_PAGINATION_DOT = "carousel_pagination_dot",
  PAGINATION_CLICK = "pagination_click",
  IMAGE_CLICK = "image_click",
  VIDEO_CLICK = "video_click",
  CLICK = "click",
  BUTTON_CLICK = "button_click",
  OPTION_SELECTION = "option_selection",
  SELECTION_CLICK = "selection_click",
  TAB_CLICK = "tab_click",
  // ✅ Newly added event types
  ICON_CLICK = "icon_click",
  LINK_CLICK = "link_click",
  CARD_ICON = "card_icon",
  CLOSE = "CLOSE",
  HEADER_CLICK = "header_click",
  CARD_CLICK = "card_click",
  TEXT_CLICK = "text_click",
  // ✅ StoryBlock event types
  KNOW_MORE = "KNOW_MORE",
  VIDEO_PLAY = "VIDEO_PLAY",
  PRODUCT_CTA = "PRODUCT_CTA",
  CLICK_CTA = "CLICK_CTA",
  THUMBNAIL_CLICK = "THUMBNAIL_CLICK",
  QUIT = "quit",
  BANNER_CLICK = "banner_click",
  CAROUSEL_CLICK = "carousel_click",
  BACK_BUTTON = "BACK",
  DEVICE_BACK = "DEVICE_BACK",
  BFL_FIELDTIMING = "bfl_fieldtimeing",
  LOAN_AMOUNT_INPUT_PDP_BFL_FIELDTIMING = "loan_amount_input_pdp_bfl_fieldTiming",
  IPO_CTA_CLICK = "ipo_cta_click",
}

export const dlCtaTextConstants = {
  ARROW_ICON: "arrow_icon",
  CLOSE_ICON: "close_icon",

  // ✅ Newly added CTA text
  READ_MORE: "read_more",
  SUBSCRIBE_NOW: "subscribe_now",
  LEFT_ARROW: "LEFT_ARROW",
  RIGHT_ARROW: "RIGHT_ARROW",
  SCROLL_TO_TOP: "scroll_to_top",
};

// Page type constants
export const dlPageTypeConstants = {
  PDP: "pdp",
  CLP: "clp",
  HOMEPAGE: "homepage",
};

// Product constants
export const dlProductConstants = {
  SOLAR_FINANCE: "solar-finance",
  LOAN: "loan",
};

// ✅ Trading Mall section titles
export const dlSectionTitleConstants = {
  OPEN_DEMAT_ACCOUNT: "Open Demat Account",
  SIMILAR_STOCKS: "Similar Stocks",
  STOCK_FINANCIALS: "Stock Financials",
  TECHNICAL_SUMMARY: "Technical Summary",
  SHAREHOLDING_PATTERN: "Shareholding Pattern",
  STOCK_PERFORMANCE: "Stock Performance",
  STOCK_LIST: "Stock List",
};

// ✅ CleverTap event names
export const cleverTapEventNames = {
  CAROUSEL_ARROW_PREV_ICON: "carousel_arrow_prev_icon",
  CAROUSEL_ARROW_NEXT_ICON: "carousel_arrow_next_icon",
  SIMILAR_STOCKS_CARD_CLICK: "similar_stocks_card_click",
};

// ✅ CleverTap journey names
export const cleverTapJourneyNames = {
  TRADING_MALL_STOCK_PDP: "TRADING MALL STOCK PDP",
  TRADING_MALL_STOCK_PLP: "TRADING MALL STOCK PLP",
};

// ✅ CleverTap article names
export const cleverTapArticleNames = {
  FINANCIALS: "FINANCIALS",
  TECHNICAL_SUMMARY: "TECHNICAL SUMMARY",
  SHAREHOLDING_PATTERN: "SHAREHOLDING PATTERN",
};

export const floatingCtaConstants = {
  DRAWER_COMPONENT_NAME: "drawer",
  COMPONENT_NAME: "drawer_popup",
  CLP_CLICKED_EVENT: "CLP_CLICKED",
  CLP_VIEWED_EVENT: "CLP_VIEWED",
  DRAWER_ICON_CLICK_TYPE: "drawer_icon_click",
  CARD_CLICK_TYPE: "promotional_popup_modal_card_click",
  ICON_CLICK_TYPE: "promotional_popup_modal_icon_click",
  VIEW_CLICK_TYPE: "promotional_popup_modal_view",
};

// ✅ Header analytics constants
export const headerConstants = {
  // Element constants
  ELEMENTS: {
    NOTIFICATION_CLOSE_ICON: "notification_close_icon",
    HEADER_SIGN_IN_ICON: "Header sign in icon",
    HEADER_EMI_ICON: "header_emi_icon",
    HEADER_CART_ICON: "Header Cart icon",
    HEADER_REWARDS_ICON: "Header Rewards icon",
    HEADER_PARTNER_ICON: "Header Partner icon",
    TOP_NAVIGATION_SIDEBAR: "top_navigation_sidebar",
    SEARCH_BACK_ICON: "back icon",
    SEARCH_ICON: "search icon",
    SEARCH_SUGGESTION: "search suggestion",
    CROSS_ICON: "cross icon",
  },

  // Component constants
  COMPONENTS: {
    HEADER: "header",
    HEADER_CART: "HeaderCart",
    HEADER_REWARD: "HeaderReward",
    HEADER_PARTNER: "HeaderPartner",
    TOP_NAVIGATION: "top_navigation",
    SEARCH_BANNER: "search_banner",
    SEARCH_BAR: "search_bar",
    SEARCH_RESULT_PAGE: "search_result_page",
  },

  // Event name constants
  EVENT_NAMES: {
    NOTIFICATION_DELETE_ICON: "NOTIFICATION_DELETE_ICON",
    NOTIFICATION_BELL_ICON: "NOTIFICATION_BELL_ICON",
    NOTIFICATION_CLOSE_ICON: "NOTIFICATION_CLOSE_ICON",
    HEADER_SIGN_IN_CLICK: "HEADER_SIGN_IN_CLICK",
    HEADER_EMI_CLICK: "HEADER_EMI_CLICK",
    HEADER_CART_CLICK: "HEADER_CART_CLICK",
    HEADER_REWARDS_CLICK: "HEADER_REWARDS_CLICK",
    HEADER_PARTNER_CLICK: "HEADER_PARTNER_CLICK",
    HEADER_MENU_CLICK: "HEADER_MENU_CLICK",
    HEADER_MENU_CLOSE_CLICK: "HEADER_MENU_CLOSE_CLICK",
    HEADER_MAIN_MENU_CLICK: "HEADER_MAIN_MENU_CLICK",
    HEADER_SIDEBAR_PROFILE_CLICK: "HEADER_SIDEBAR_PROFILE_CLICK",
    HEADER_SIDEBAR_MENU_BUTTON_CLICK: "HEADER_SIDEBAR_MENU_BUTTON_CLICK",
    SEARCH_BACK_CLICK: "SEARCH_BACK_CLICK",
    SEARCH_SUBMIT: "SEARCH_SUBMIT",
    SEARCH_SUGGESTION_CLICK: "SEARCH_SUGGESTION_CLICK",
    SEARCH_HISTORY_DELETE: "SEARCH_HISTORY_DELETE",
    TOP_NAVIGATION_BAR_HEADER_ICON_CLICK: "top_navigation_bar_header_icon_click",
    SEARCH_BAR_ICON_CLICK: "search_bar_icon_click",
    SEARCH_BAR_TAB_CLICK: "search_bar_tab_click",
    BOTTOM_NAVIGATION_ICON_CLICK: "bottom_navigation_icon_click",
    BOTTOM_NAVIGATION_BACK_CLICK: "bottom_navigation_back_click",
    FOOTER_ICON_CLICK: "footer_icon_click",
    FOOTER_LINK_CLICK: "footer_link_click",
    FOOTER_DOWNLOAD_ICON_CLICK: "footer_download_icon_click",
  },

  // Section title constants
  SECTION_TITLES: {
    HEADER: "Header",
    HEADER_CART: "Header Cart icon",
    SEARCH: "Search",
    SEARCH_HISTORY: "Search History",
    SEARCH_RESULT: "Search Result",
  },

  // CTA text constants
  CTA_TEXT: {
    NOTIFICATION_CLOSE: "Notification close icon",
    HEADER_SIGN_IN: "Header sign in icon",
    EMI_CARD: "emi_card",
    HEADER_CART: "Header Cart icon",
    PRIME: "Prime",
    PARTNERS: "Partners",
    MENU: "Menu",
    CLOSE_MENU: "Close Menu",
  },

  // Search specific constants
  SEARCH: {
    EVENT_CLICK: {
      ICON_CLICK: "icon_click",
      INPUT_TEXT: "input_text",
      OPTION_SELECTION: "option_selection",
    },
    TARGET: {
      SEARCH_RESULT_REMOVE_OPTION: "search_result_remove_option",
      SEARCH_BANNER_DIRECTION_ICON: "search_banner_direction_icon",
      SEARCH_BAR_INITIATION: "search_bar_initiation",
      SEARCH_BANNER_OPTION_SELECTION: "search_banner_option_selection",
    },
    SUB_SECTION: {
      CROSS_ICON: "cross icon",
    },
  },

  // Mobile Navigation specific constants
  MOBILE_NAVIGATION: {
    ELEMENTS: {
      BOTTOM_NAVIGATION_ICONS: "bottom-navigation-icons",
      BOTTOM_NAVIGATION_MENU: "bottom-navigation-menu",
    },
    COMPONENTS: {
      BOTTOM_NAVIGATION_MOBILE: "bottomNavigationMobile",
    },
    EVENT_TYPES: {
      CARD_CLICK: "card_click",
      ICON_CLICK: "icon_click",
      LINK_CLICK: "link_click",
      SOCIAL_ICON_CLICK: "SOCIAL_ICON_CLICK",
    },
    EVENT_NAMES: {
      BOTTOM_NAV_MENU_CLICK: "BOTTOM_NAV_MENU_CLICK",
      BOTTOM_NAV_ICON_CLICK: "BOTTOM_NAV_ICON_CLICK",
      HAMBURGER_MENU_CLOSE_CLICK: "HAMBURGER_MENU_CLOSE_CLICK",
      HAMBURGER_MENU_CARD_CLICK: "HAMBURGER_MENU_CARD_CLICK",
      CROSS_SELL_LINK_CLICK: "CROSS_SELL_LINK_CLICK",
      HAMBURGER_MENU_LINK_CLICK: "HAMBURGER_MENU_LINK_CLICK",
      SOCIAL_MEDIA_ICON_CLICK: "SOCIAL_MEDIA_ICON_CLICK",
    },
    CTA_TEXT: {
      MENU: "Menu",
      BOTTOM_NAVIGATION_ICONS: "bottom-navigation-icons",
    },
  },
};
